import { Component, ViewChild, OnDestroy } from '@angular/core';
import {
  Content,
  IonicPage,
  NavController,
  NavParams
} from 'ionic-angular';
import { ImagesService } from '../../shared/services/images.service';
import { OauthService } from '../../shared/services/oauth.service';
import { Subject } from 'rxjs/Subject';
import { Search } from '../../shared/models/search/search.model';
import { BlogArticle } from '../../shared/models/blogArticle/blogArticle.model';
import { BlogArticleService } from '../../shared/services/blogArticle.service';
import { AuthService } from '../../shared/services/auth.service';
import { CorePage } from '../../shared/interfaces/corePage.interface';
import { SessionStorageService } from '../../shared/services/sessionStorage.service';
import { LoadingService } from '../../shared/services/loading.service';
import { UserStorageService } from '../../shared';
import {BlogThemeService} from "../../shared/services/blogTheme.service";

/**
 * Generated class for the BlogArticleListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-blog-article-list',
  templateUrl: 'blog-article-list.html'
})
export class BlogArticleListPage implements CorePage, OnDestroy {
  public allowedMode = ['elu', 'salarie'];
  public authService: any;
  public isComponentReady: boolean = false;
  @ViewChild(Content) content: Content;
  public blogArticles: Array<BlogArticle>;

  public searchQuery$ = new Subject<Search>();

  public sortOptions = [
    { value: 'date', label: 'Date' },
    { value: 'likeQuantity', label: 'Likes' }
  ];

  public menuFilters: boolean = false;
  public filters = {
    termSearch: '',
    themeIds: [],
    themeFilters: [],
    favoris: null,
    orderBy: 'date',
    order: 'desc',
    orderMessage: null,
    favorisMessage: null,
    type: null,
    home: null,
    pageTitle: '',
  };

  public offset: number = 0;
  public limit: number = 15;

  public pageTitle: string = 'Blog\'info';

  public totalPages = false;
  public isLoading = new Subject();
  public noResult = false;

  public toggleFavorisIterator: number = 0;

  private canAutoMoveToDetail = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private blogArticleService: BlogArticleService,
    private blogThemeService: BlogThemeService,
    private oauthService: OauthService,
    private imagesService: ImagesService,
    private ssService: SessionStorageService,
    private loadingService: LoadingService,
    private storage: UserStorageService
  ) {
    this.authService = new AuthService(
      this.allowedMode,
      this.navCtrl,
      this.oauthService,
      this.storage
    );

    // Load filters from session, if none then use default filters
    const sessionFilters = ssService.getBlogArticleFilters();
    if (null !== sessionFilters) {
      this.filters = sessionFilters;
    }

    this.initializeParams();
  }

  ionViewCanEnter() {
    return this.authService.ionViewCanEnter();
  }

  ionViewWillEnter() {
    const sessionFilters = this.ssService.getBlogArticleFilters();
    if (null !== sessionFilters) {
      this.filters = sessionFilters;
    }
    if (null === this.filters.type) {
      this.filters.type = 'BLOG';
    }
  }

  ionViewDidEnter() {
    // Force search on page re-enter
    // Note : PhpStorm thinks that this method is unused, but it is called by ionic
    this.refresh();
  }

  refresh() {
    this.offset = 0;
    this.loadingService.start();
    this.menuFilters = false;
    this.searchQuery$.next(this.createSearchQuery('init') as Search);
  }

  createSearchQuery(action: string): Search {
    this.filters.themeIds = this.filters.themeFilters.map(f => (f.checked ? f.id : null));

    const params = {
      term: this.filters.termSearch,
      action: action,
      themes: this.filters.themeIds,
      type: this.filters.type,
      limit: this.limit,
      offset: this.offset,
      favoris: this.filters.favoris,
      order: this.filters.order,
      orderBy: this.filters.orderBy
    };

    return new Search(params);
  }

  ngOnDestroy() {
    this.isLoading.unsubscribe();
    this.searchQuery$.unsubscribe();
  }

  initializeParams() {

    if (this.navParams.get('filters')) {
      this.filters = this.navParams.get('filters');
      this.pageTitle = this.navParams.get('pageTitle') ? this.navParams.get('pageTitle') : 'Article';
      console.log(this.filters.termSearch);
    }

    this.blogThemeService.searchAllThemes(null, 'search').subscribe(res => {
      if (res.data.data) {
        this.filters.themeFilters = res.data.data.sort( (a, b) => {
          return a.ordre - b.ordre;
        });
      }
    });
    // Note : Code commenté pour ne pas prendre en compte les thèmes souscrits par le bénéficiaire, actuellement non livré.
    //
    // const user = this.lsService.getUser();
    // if (user && 'blogThemes' in user && user.blogThemes && this.navParams.get('start') && this.filters.type === 'BLOG') {
    //   this.filters.themeIds = user.blogThemes.map(f => f.id);
    //   this.filters.themeFilters = user.blogThemes.map(f => {
    //     return {
    //       id: f.id,
    //       libelle: f.libelle,
    //       checked: true
    //     };
    //   });
    // } else {
    this.filters.themeIds = this.filters.themeFilters.map(
      f => (f.checked ? f.id : null)
    );
    // }
    this.offset = this.offset === this.limit ? 0 : this.offset; // init offset to 0 if paged 1

    this.canAutoMoveToDetail = true;
    this.initializeBlogArticles();
  }

  initializeBlogArticles() {
    this.blogArticleService.getAll(this.searchQuery$).subscribe(response => {
      const data = response.data;
      const action = response.action;

      if (action === 'scroll' && data.data.length > 0) {
        for (let i = 0; i < data.data.length; i++) {
          this.blogArticles.push(data.data[i]);
        }
        this.totalPages = data.data.length < this.limit;
        this.offset += this.limit;
        this.isLoading.next();
      } else if (action === 'scroll' && data.data.length === 0) {
        this.totalPages = true;
        this.isLoading.next();
      } else {
        this.blogArticles = data.data;
        this.offset = this.limit;

        this.totalPages = data.data.length < this.limit;
        this.noResult = data.data.length === 0;
      }

      this.content.resize();

      // Automatically redirect to the article detail page IF only 1 article AND no filters used
      if (this.canAutoMoveToDetail && this.blogArticles.length === 1) {
        this.onClick(this.blogArticles.pop().id);
      }
      // Set to false because we've now passed the page arrival,
      // all following requests will be filters UNLESS the user clicks on the menu entry for the category
      this.canAutoMoveToDetail = false;
      this.isComponentReady = true;
      this.loadingService.end();
    });
    this.searchQuery$.next(this.createSearchQuery('init') as Search);
  }

  doInfinite(infiniteScroll) {
    this.searchQuery$.next(this.createSearchQuery('scroll') as Search);

    this.isLoading.first().subscribe(() => {
      infiniteScroll.complete();
    });
  }

  onSearch($event) {
    let val;
    let searchActive = false;
    this.menuFilters = false;
    this.loadingService.start();

    switch ($event.action) {
      case 'search':
        val = $event.event.target.value;

        if (
          val &&
          ((val && val.length >= 3) ||
            (val.length === 0 && this.filters.termSearch.trim() !== ''))
        ) {
          // search if val is > 3 letters
          this.noResult = false;
          this.filters.termSearch = val;
          this.offset = null; // init offset
          searchActive = true;
        } else if (!val) {
          this.noResult = false;
          this.filters.termSearch = '';
          this.offset = null; // init offset
          searchActive = true;
        }
        break;

        // Suppression du cas "Mis en avant
      // case 'favoris':
      //   const filterList = [
      //     null,
      //     { k: 1, l: 'Oui' },
      //     { k: 0, l: 'Non' }
      //   ];
      //   this.toggleFavorisIterator++;
      //   if (this.toggleFavorisIterator > filterList.length - 1) {
      //     this.toggleFavorisIterator = 0;
      //   }
      //   if (filterList[this.toggleFavorisIterator] === null) {
      //     this.filters.favoris = null;
      //     this.filters.favorisMessage = null;
      //   } else {
      //     this.filters.favoris = filterList[this.toggleFavorisIterator].k;
      //     this.filters.favorisMessage = filterList[this.toggleFavorisIterator].l;
      //   }
      //
      //   this.noResult = false;
      //   this.offset = null; // init offset
      //   searchActive = true;
      //   break;

      case 'orderBy':
        this.noResult = false;
        this.offset = null;
        searchActive = true;
        break;
    }

    if (searchActive) {
      this.ssService.setBlogArticleFilters(this.filters);
      this.searchQuery$.next(this.createSearchQuery('search'));
    } else {
      this.loadingService.start();
    }
  }

  onFilterThemes() {
    this.navCtrl.push('BlogArticleListFiltersPage', { filters: this.filters }); // link to filters page
  }

  onClick(id) {
    this.navCtrl.push('BlogArticleDetailPage', { blogArticle: id, pageTitle: this.pageTitle });
  }

  getImage(id: number, images: Array<any>, type: string, typeImage: string) {
    const image = this.imagesService.getImage(id, images, type, typeImage);

    if (image) {
      return image;
    }

    return 'assets/img/default.jpg';
  }

  clickBlogArticleUrl(url) {
    if (url) {
      window.open(url, '_system');
    }
  }

  onUserBoard() {
    this.navCtrl.setRoot('UserBoardPage');
  }

  getBreadcrumb() {
    if (this.filters) {
      switch (this.filters.type) {
        case 'INFO':
          return 'Actualités';
        case 'PROMO':
          return 'Promotions';
        case 'LEGAL':
          return 'Mentions légales';
        case 'EDITO':
          return 'Édito';
        case 'PV_CE':
          return 'PV de réunions';
        default:
          return 'Actualités';
      }
    } else {
      return 'Actualités';
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/blog-article-list/blog-article-list.ts